import React, { useEffect, useRef, useState } from 'react';
import { modifiers, Size } from '@outdoria/ui';
import s from './Image.module.scss';

type ImageProps = {
  src: string;
  size?: Size;
  isPixelated?: boolean;
  alt?: string;
};
export const Image = React.forwardRef<HTMLImageElement, ImageProps>(
  ({ src, size, isPixelated = false, alt = '' }, ref) => {
    return (
      <img
        className={modifiers(s, 'image', String(size), { isPixelated })}
        ref={ref}
        src={src}
        alt={alt}
      />
    );
  },
);

export const useImgSize = () => {
  const ref = useRef<HTMLImageElement>(null);
  const [imgSize, setImgSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const img = ref.current;
    if (!img) return;

    const updateSize = () => {
      const width = img.naturalWidth;
      const height = img.naturalHeight;

      setImgSize({ width, height });
    };

    // Image is already loaded (from cache)
    if (img.complete && img.naturalWidth) {
      updateSize();
    } // Wait for the image to load
    else {
      img.addEventListener('load', updateSize);
    }

    return () => {
      img.removeEventListener('load', updateSize);
    };
  }, [ref.current]);

  return { ref, imgSize };
};
